function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AdditionalPropertyValueType } from 'invision-core/src/components/metadata/codes/codes.additional.properties.constants';
import { getNameForCode } from 'invision-core/src/components/metadata/codes/codes.helpers';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import pathOr from 'ramda/src/pathOr';
import LocaleKeys from '../../../../../../locales/keys';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../../../../../customer/addresses/addresses.constants';
import { mobileNumberPortabilitySetEditAdditionalProperty, mobileNumberPortabilitySetEditAdditionalPropertyOnChange, updateMobileNumberPortabilityAddressModel, updateMobileNumberPortabilityModel } from '../../../../../../reducers/actions/mobile.number.portability.actions';
import { MnpAdditionalPropertiesSelector, MobileNumberPortabilityAddressModelSelector, MobileNumberPortabilityModelSelector, PostalCodeRegexSelector, StateOptionsSelector } from '../../../../../../reducers/selectors/mobile.number.portability.selectors';
import clone from 'ramda/src/clone';
import propEq from 'ramda/src/propEq';
import { CurrentAddressesSelector } from '../../../../../../reducers/selectors/customer.addresses.selectors';
import { addressHelper as AddressHelper } from 'invision-core/src/utilities/address.helper';
import { CurrentBusinessUnitSelector } from 'invision-core/src/components/session/businessunit.selectors';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../../../../shared/contextualComponents/address/address.validator.helper';
import { setForceShowEditFormAddress, validateAddress } from '../../../../../../reducers/actions/address.component.actions';
import { EditCustomerInfoSelector } from '../../../../../../reducers/selectors/new.connect.wizard.selectors';
var MobileNumberPortabilityPopupController = /*#__PURE__*/function () {
  function MobileNumberPortabilityPopupController($ngRedux, uiNotificationService, $timeout) {
    _classCallCheck(this, MobileNumberPortabilityPopupController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      addressFormModel: {},
      AddressHelper: AddressHelper,
      CoreLocaleKeys: CoreLocaleKeys,
      formMaxLengthValidation: ADDRESS_FORM_FIELD_MAX_LENGTH,
      handleAddressChange: this.handleAddressChange.bind(this),
      handleFormChanged: this.handleFormChanged.bind(this),
      LocaleKeys: LocaleKeys,
      onClose: this.onClose.bind(this),
      onListUpdated: this.onListUpdated.bind(this),
      onMobileNumberPortabilityAdditionalPropertyChange: this.onMobileNumberPortabilityAdditionalPropertyChange.bind(this),
      onPopupSubmit: this.onPopupSubmit.bind(this),
      onAddressFormUpdate: this.onAddressFormUpdate.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(MobileNumberPortabilityPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      this.disconnectRedux = this.connectRedux();
      this.existingNumberRegex = this.attribute.regularExpression ? new RegExp(this.attribute.regularExpression) : null;
      this.currentAddresses = clone(this.state.currentAddresses);
      this.mnpAdditionalProperties = clone(this.state.mnpAdditionalProperties);
      if (this.state.currentAddresses.length) {
        this.selectedAddress = this.currentAddresses[0];
        this.handleAddressChange();
      } else {
        this.onAddressFormUpdate({
          addressLine1: this.state.editCustomerInfo.addressLine1 || this.state.addressData.LineOne,
          addressLine2: this.state.editCustomerInfo.addressLine2 || this.state.addressData.LineTwo,
          country: this.state.addressData.Country || this.state.editCustomerInfo.country,
          city: this.state.editCustomerInfo.city || this.state.addressData.City,
          stateRegionProvince: this.state.editCustomerInfo.stateRegionProvince || this.state.addressData.State,
          postalCode: this.state.editCustomerInfo.postalCode || this.state.addressData.PostalCode
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "connectRedux",
    value: function connectRedux() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          additionalPropertyLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdditionalProperty, store),
          additionalPropertyValueLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdditionalPropertyValue, store),
          additionalPropValueSelector: MetadataSelectors.codes.MetadataCodeTypeIntegerSelector(MetadataConstants.codes.AdditionalPropertyValue, store),
          addressCountriesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressCountry, store),
          addressCountriesOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.AddressCountry, store),
          addressData: MobileNumberPortabilityAddressModelSelector(store).asMutable(),
          addressStatesAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
          addressStatesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
          currentAddresses: CurrentAddressesSelector(store),
          currentBusinessUnit: CurrentBusinessUnitSelector(store),
          editCustomerInfo: EditCustomerInfoSelector(store),
          mnpAdditionalProperties: MnpAdditionalPropertiesSelector(store),
          portabilityData: MobileNumberPortabilityModelSelector(store).asMutable(),
          postalCodeRegex: PostalCodeRegexSelector(store),
          providerAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.MnpServiceProviderConfiguration, store),
          providerLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.MnpServiceProviderConfiguration, store),
          providerOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.MnpServiceProviderConfiguration, store),
          regularExpressionLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.RegularExpression, store),
          stateOptions: StateOptionsSelector(store),
          unvalidatedAddresses: UnvalidatedAddressesSelector(store),
          validatedAddresses: ValidatedAddressesSelector(store)
        };
      };
      var controllerActions = {
        mobileNumberPortabilitySetEditAdditionalProperty: mobileNumberPortabilitySetEditAdditionalProperty,
        mobileNumberPortabilitySetEditAdditionalPropertyOnChange: mobileNumberPortabilitySetEditAdditionalPropertyOnChange,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        updateMobileNumberPortabilityAddressModel: updateMobileNumberPortabilityAddressModel,
        updateMobileNumberPortabilityModel: updateMobileNumberPortabilityModel,
        validateAddress: validateAddress
      };
      return this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "showHeaderErrorMessages",
    value: function showHeaderErrorMessages() {
      return !this.portabilityForm.$submitted;
    }
  }, {
    key: "onAddressFormUpdate",
    value: function onAddressFormUpdate(addressFormModel) {
      var payload = {
        LineOne: addressFormModel.addressLine1,
        LineTwo: addressFormModel.addressLine2,
        City: addressFormModel.city,
        Country: addressFormModel.country,
        State: addressFormModel.stateRegionProvince,
        PostalCode: addressFormModel.postalCode
      };
      this.addressFormModel.addressLine1 = addressFormModel.addressLine1;
      this.addressFormModel.addressLine2 = addressFormModel.addressLine2;
      this.addressFormModel.city = addressFormModel.city;
      this.addressFormModel.country = addressFormModel.country;
      this.addressFormModel.stateRegionProvince = addressFormModel.stateRegionProvince;
      this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
      this.actions.updateMobileNumberPortabilityAddressModel(payload);
    }
  }, {
    key: "updatePortabilityModel",
    value: function updatePortabilityModel() {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      Object.assign(this.state.portabilityData, model);
      this.actions.updateMobileNumberPortabilityModel(this.state.portabilityData);
    }
  }, {
    key: "setVars",
    value: function setVars() {
      this.postalCodeRegex = {
        regEx: '',
        mask: ''
      };
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      this.state.portabilityData = {
        existingNumber: null,
        provider: null
      };
      this.state.addressData = {
        LineOne: null,
        LineTwo: null,
        Country: null,
        City: null,
        State: null,
        PostalCode: null
      };
      this.formErrors = [];
      if (this.portabilityForm) {
        this.portabilityForm.$setPristine();
        this.portabilityForm.$setUntouched();
      }
    }
  }, {
    key: "onPopupSubmit",
    value: function onPopupSubmit() {
      var _this2 = this;
      this.portabilityForm.$setSubmitted();
      this.validateAddressWithAPI().then(function () {
        var addressKey = _this2.getAddressKey(),
          validatedAddress = _this2.state.validatedAddresses[addressKey];
        if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress) || _this2.bypassValidation) {
          var providerItem = _this2.state.providerAll.find(function (item) {
            return item.Value === _this2.state.portabilityData.provider;
          });
          _this2.state.portabilityData.providerLabel = providerItem.Name;
          _this2.onContinue()(clone(_this2.state.addressData), clone(_this2.state.portabilityData));
          _this2.resetForm();
        } else {
          _this2.actions.setForceShowEditFormAddress(false);
          _this2.uiNotificationService.transientError(i18n.translate(_this2.LocaleKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
        }
      }).catch(function (err) {
        _this2.uiNotificationService.transientError(err.translatedMessage);
      });
    }
  }, {
    key: "onMobileNumberPortabilityAdditionalPropertyChange",
    value: function onMobileNumberPortabilityAdditionalPropertyChange(id, newValue) {
      var findType = this.state.mnpAdditionalProperties.find(propEq(id, 'id'));
      switch (findType.type) {
        case AdditionalPropertyValueType.SINGLE_TEXT:
          this.actions.mobileNumberPortabilitySetEditAdditionalPropertyOnChange(id, [newValue]);
          break;
        case AdditionalPropertyValueType.MULTIPLE_TEXT:
          this.actions.mobileNumberPortabilitySetEditAdditionalPropertyOnChange(id, newValue);
          break;
        case AdditionalPropertyValueType.SELECT:
        case AdditionalPropertyValueType.BOOLEAN:
          newValue = newValue ? [getNameForCode(this.state.additionalPropValueSelector, newValue)] : [];
          this.actions.mobileNumberPortabilitySetEditAdditionalPropertyOnChange(id, newValue);
          break;
        default:
          break;
      }
    }
  }, {
    key: "onListUpdated",
    value: function onListUpdated() {
      this.actions.mobileNumberPortabilitySetEditAdditionalProperty(this.mnpAdditionalProperties);
    }
  }, {
    key: "handleAddressChange",
    value: function handleAddressChange() {
      var selectedAddress = this.selectedAddress || {};
      this.onAddressFormUpdate({
        addressLine1: selectedAddress.LineOne || null,
        addressLine2: selectedAddress.LineTwo || null,
        country: selectedAddress.Country || this.addressFormModel.country,
        city: selectedAddress.City || null,
        stateRegionProvince: selectedAddress.State || null,
        postalCode: selectedAddress.PostalCode || null
      });
    }
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['portabilityForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['portabilityForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true,
          DefaultHome: true,
          DefaultPostal: true,
          DefaultService: true
        };
      this.portabilityForm['addressWrapupController.singleAddressFormFormApi'].submitted = true;
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else if (!unvalidatedAddress.addressLine1 || !unvalidatedAddress.addressLine2 || !unvalidatedAddress.country || !unvalidatedAddress.postalCode || !unvalidatedAddress.city || !unvalidatedAddress.stateRegionProvince) {
        this.bypassValidation = true;
        return Promise.resolve(200);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.onFormChanged()(this.state.portabilityData);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.resetForm();
      this.onCancel();
    }
  }]);
}();
export default {
  template: require('./mobile.number.portability.popup.template.html'),
  controller: MobileNumberPortabilityPopupController,
  bindings: {
    attribute: '<',
    onCancel: '&',
    onContinue: '&'
  }
};